import React from 'react';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 bg-brand-cream text-center" data-id="element-28">
      <div className="container mx-auto px-4 max-w-2xl" data-id="element-29">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-brand-dark mb-6" data-id="element-30">
          Tu próxima quincena puede ser diferente
        </h2>
        <p className="font-sans text-xl text-brand-text/80 mb-8" data-id="element-31">
          Empieza hoy. En 10 minutos sabrás en qué se va tu dinero. En 7 días
          tendrás control real.
        </p>

        <button onClick={scrollToOffer} className="bg-brand-green hover:bg-brand-dark text-white font-heading font-bold py-4 px-10 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:scale-[1.02] flex items-center justify-center gap-2 text-lg mx-auto mb-6" data-id="element-32">
          Empezar mi plan de 7 días
          <ArrowRight className="h-5 w-5" data-id="element-33" />
        </button>

        <p className="text-sm font-medium text-brand-green/80 flex items-center justify-center gap-2" data-id="element-34">
          <span data-id="element-35">Sistema de 7 días</span>
          <span className="w-1 h-1 bg-brand-green/40 rounded-full" data-id="element-36"></span>
          <span data-id="element-37">Sin Excel</span>
          <span className="w-1 h-1 bg-brand-green/40 rounded-full" data-id="element-38"></span>
          <span data-id="element-39">Descarga inmediata</span>
        </p>
      </div>
    </section>;
}